import React from 'react';
import { useTranslation } from 'react-i18next';
import DAProtectIndicator from '@wix/da-ds/pkg/Indicators/DAProtect';

import s from './DAProtectNotice.scss';

const DAProtectNotice: React.FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <DAProtectIndicator variant="active" />
      <div className={s['protect-notice']}>
        {t('deviationSubmit.footer.protectNotice', {
          postProcess: 'reactPostprocessor',
          protectLink: (
            <a
              href={t('deviationSubmit.footer.protectNotice.url')}
              rel="noopener noreferrer"
              target="_blank"
              className="text-link-level-2-secondary"
            >
              {t('deviationSubmit.footer.protectNotice.link')}
            </a>
          ),
        })}
      </div>
    </div>
  );
};
DAProtectNotice.displayName = 'DAProtectNotice';

export default DAProtectNotice;
